import { Action } from '../action.type';
import { AppState } from '../app.state';
import { CLEAR_ERROR } from './error.action.type';

export const errorReducers = (state: AppState, action: Action): AppState => {
  switch (action.type) {
    case CLEAR_ERROR:
      return clearErrorReducer(
        state,
        action as Action<
          'authentication' | 'user' | 'seasonFights' | 'userSeason' | 'season'
        >,
      );
    default:
      return state;
  }
};

const clearErrorReducer = (
  state: AppState,
  action: Action<
    'authentication' | 'user' | 'seasonFights' | 'userSeason' | 'season'
  >,
): AppState => ({
  ...state,
  [action.payload]: {
    ...state[action.payload],
    error: null,
  },
});
